import { Grid, Switch, Typography } from '@mui/material';

export const StatusSwitch = ({
  newData,
  handleSwitchChange,
  field,
  ifActive = 'Active',
  ifInactive = 'Inactive'
}) => {
  return (
    <Grid container item xs={12} style={{ alignItems: 'center' }}>
      <Grid item xs={2}>
        <Typography>Status:</Typography>
      </Grid>
      <Grid item xs={2}>
        <Switch
          checked={newData[field]}
          onChange={() => handleSwitchChange(field, !newData[field])}
          color="primary"
        />
      </Grid>
      <Grid item xs={6}>
        <Typography
          style={{
            color: newData[field] ? 'green' : 'red'
          }}
        >
          {newData[field] ? ifActive : ifInactive}
        </Typography>
      </Grid>
    </Grid>
  );
};
